import styled, { css } from 'styled-components';
import { ISyncAnimation } from '../../../interfaces/ISyncAnimation';

export const SecondScreenContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 90rem;
  margin-top: 3rem;
  margin-bottom: 1rem;
  gap: 2rem;
`;

export const SecondScreenTitle = styled.div`
  width: 100%;
  max-width: 71.25rem;

  text-align: center;
  color: #fff;
  font-family: 'Inter', Sans-serif;
  font-size: 36px;
  font-weight: 300;
  line-height: 1;
`;

export const SecondScreenContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;

  @media (max-width: 1023px) {
    flex-direction: column;
  }
`;

export const ContentLeft = styled.div<ISyncAnimation>`
  display: flex;
  width: 100%;
  max-width: 40rem;
  margin-top: -8rem;

  img {
    margin-left: -2rem;
    width: 100%;
    max-width: 40rem;
  }

  @keyframes slideFromLeft {
    from {
      transform: translateX(-100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  ${(props) =>
    props.isVisible &&
    css`
      animation: slideFromLeft 1s ease-out;
    `}

  @media (max-width: 1023px) {
    margin-top: -5rem;
    align-self: center;
    img {
      margin-left: 0;
    }
  }
`;

export const ContentRight = styled.div<ISyncAnimation>`
  display: flex;
  flex-direction: column;
  width: 29.625rem;
  height: 100%;
  margin-top: 2rem;
  margin-left: 3rem;

  @keyframes slideFromRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  ${(props) =>
    props.isVisible &&
    css`
      animation: slideFromRight 1s ease-out;
    `}

  @media (max-width: 1023px) {
    align-self: center;
    width: 70%;
    max-width: 29.625rem;
  }
`;

export const ContentRightText1 = styled.span`
  color: #fff;
  font-family: 'Open Sans', Sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.7em;
`;

export const ContentRightText2 = styled.span`
  margin-top: 3rem;

  color: #fff;
  font-family: 'Open Sans', Sans-serif;
  font-size: 25px;
  font-weight: 700;
  line-height: 1;
`;

export const ContentRightText3 = styled.ul`
  color: #fff;
  font-family: 'Open Sans', Sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.7em;

  li {
    list-style: disc;
  }
`;
